module.exports = __webpack_public_path__ + "windowsHello@2x.964775eb8eb9d6dafa64242dcf7685a8.png";